module.exports = __webpack_public_path__ + "static/media/image_3_0 1.8af16aca.png";